import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Box, IconButton, Modal, Typography, Card, CardMedia } from '@mui/material';
import { isEmpty } from 'lodash';
import CloseIcon from '@mui/icons-material/Close';
// import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import LoadingSliderComponent from '../LoadingSliderComponent';

const OpenModalFromUrl = ({
  openModal,
  setOpenModal,
  isFullScreen,
  isLoading,
  loadingTime,
  url,
  title,
  isLoadingIpsilum,
  isImage,
  isComponent,
  component,
  idComponent
}) => {
  const body = (
    <Box
      style={{
        position: 'absolute',
        backgroundColor: 'white',
        height: isFullScreen ? '100%' : '95%',
        width: isFullScreen ? '100%' : '95%',
        top: isFullScreen ? '0%' : '2.5vh',
        left: isFullScreen ? '0%' : '2.5vw'
      }}
    >
      {isLoading && (
        <LoadingSliderComponent loadingTime={loadingTime} isLoadingIpsilum={isLoadingIpsilum} />
      )}

      <Box
        height="5%"
        width="100%"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 16px'
        }}
      >
        {!isEmpty(title) && (
          <Typography variant="h5" fontWeight="bold">
            {title}
          </Typography>
        )}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {/* <IconButton
            onClick={() => {
              window.open(url);
            }}
            sx={{ marginLeft: 'auto' }}
          >
            <OpenInNewIcon />
          </IconButton> */}
          <IconButton
            color="success"
            variant="outlined"
            onClick={() => {
              setOpenModal(false);
            }}
            sx={{ marginLeft: '16px' }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>

      {isEmpty(url) && !isComponent && (
        <Alert severity="warning">No se puede mostrar el directorio</Alert>
      )}
      {!isEmpty(url) && !isComponent && (
        <Box height="95%" display="flex" justifyContent="center">
          {isImage && (
            <Card height="100%" width="100%">
              <CardMedia component="img" image={url} height="100%" width="100%" />
            </Card>
          )}
          {!isImage && <iframe title="WebPage" src={url} width="100%" height="100%" />}
        </Box>
      )}

      {isComponent && isEmpty(url) && (
        <Box height="95%" width="100%">
          <>{component()}</>
        </Box>
      )}
    </Box>
  );
  if (isComponent) {
    const componentBox = document.getElementById(idComponent);
    if (!isEmpty(componentBox)) componentBox.style.height = '95vh';
  }

  return (
    <>
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        {body}
      </Modal>
    </>
  );
};
export default OpenModalFromUrl;

OpenModalFromUrl.defaultProps = {
  isLoading: false,
  isFullScreen: false,
  title: '',
  loadingTime: 5000,
  isLoadingIpsilum: false,
  isImage: false,
  isComponent: false,
  component: () => {},
  idComponent: ''
};
OpenModalFromUrl.propTypes = {
  url: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  loadingTime: PropTypes.number,
  openModal: PropTypes.bool.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  isFullScreen: PropTypes.bool,
  title: PropTypes.string,
  isLoadingIpsilum: PropTypes.bool,
  isImage: PropTypes.bool,
  isComponent: PropTypes.bool,
  component: PropTypes.func,
  idComponent: PropTypes.string
};
